import React, { useEffect, useState } from 'react';
import { showResponseSnackBar, DATE_RANGE_DEFAULT } from 'consts';
import { useSelector } from 'react-redux';
import Button from 'tradevan-ui/Button';
import { isUndefined } from 'tradevan-ui/consts';
import useAxios from 'axios/useAxios';
import { MethodEnum } from 'axios/type';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import StatusEnum from 'axios/enum';
import { formatDate } from 'components/DatePicker/consts';
import { useForm } from 'react-hook-form';
import { Ipage } from 'components/Table/type';
import TableTit from 'components/_form/TableTit';
import Rim from 'components/_form/Rim';
import DivSX from 'tradevan-ui/@emotion/DivSX';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import LogRecordModal from 'view/Layout/Project/components/LogRecordModal';
import { FIRST_PAGE, initPage } from 'components/Table/consts';
import {
  EnumFunctionId,
  EnumMasterSort,
  EnumRetailerSetup,
} from 'view/Layout/enum';
import { initMasterSort } from 'view/Layout/consts';
import { IqueryDateList } from 'view/Layout/type';
import {
  EnumMaster,
  Idetail,
  QueryReturnState,
  IretailerSetupOrder,
  QueryOrderForm,
  useInitMaster,
  useInitRetailerSetup,
  QueryOrderFormDetail,
  Imaster,
  EnumDetail,
} from './init';
import QuerySecion from './components/QuerySecion';
import { Iconditions, IqueryOrderRequest } from './type';
import ResultSecion from './components/ResultSecion';
import DownloadBtn from '../components/DownloadBtn';
import { nameMaster } from './consts';

import useQueryDate from './components/QuerySecion/useQueryDate';

/** 訂單 */
const QueryReturn = () => {
  const initRetailerSetup = useInitRetailerSetup();
  const axios = useAxios();
  /** 表單顯示欄位設定 */
  const [retailerSetup, setRetailerSetup] = useState(initRetailerSetup);
  /** 體系別 OpTrs /登入者資料 */
  const userInfoReducer = useSelector(getUserInfoReducer);
  const initState: QueryReturnState = {
    master: useInitMaster(),
    masterSort: initMasterSort,
    detail: [],
    pageObj: initPage,
    showResult: false,
    retailerTypeOption: [],
    showLogRecordModal: false,
    logRecordData: [],
    isNoViewedPrint: false,
    isNoViewedPrintMessage: '',
    queryDateList: [],
  };

  // #region useForm系列

  // #region QueryOrderForm
  const initQueryOrderForm: QueryOrderForm = {
    master: initState.master,
    masterSort: initState.masterSort,
  };
  const formReturn = useForm<QueryOrderForm>({
    defaultValues: initQueryOrderForm,
  });

  const { watch, setValue, handleSubmit, reset } = formReturn;

  // #endregion

  // #region QueryOrderDetailForm

  const formReturnDetail = useForm<QueryOrderFormDetail>({
    defaultValues: {
      master: initState.master,
      detail: initState.detail,
      pageObj: initState.pageObj,
      masterSort: initState.masterSort,
    },
  });

  const { setValue: setValueDetail, watch: watchDetail } = formReturnDetail;
  const master = watch('master');
  const pageObj = watchDetail('pageObj');
  const detail = watchDetail('detail');
  const masterSort = watch('masterSort');
  // #endregion

  // #endregion useForm系列

  /** 查覽結果 */
  const [showResult, setShowResult] = useState(initState.showResult);
  /** 操作歷程 dialog */
  const [showLogRecordModal, setShowLogRecordModal] = useState(
    initState.showLogRecordModal,
  );
  /** 操作歷程 資料 */
  const [logRecordData, setLogRecordData] = useState(initState.logRecordData);
  /** 體系別選項 */
  const [retailerTypeOption, setRetailerTypeOption] = useState(
    initState.retailerTypeOption,
  );
  /** 未點閱列印 */
  const [isNoViewedPrintChecked, setIsNoViewedPrintChecked] = useState(
    initState.isNoViewedPrint,
  );
  /** 未點閱列印提示訊息 */
  const [isNoViewedPrintMessage, setisNoViewedPrintMessage] = useState(
    initState.isNoViewedPrintMessage,
  );

  /** 日期下拉選單 */
  const [queryDateList, setQueryDateList] = useState<IqueryDateList[]>([]);
  const { queryDateOpTrs, handleQueryDateOptionChange } = useQueryDate(
    queryDateList,
    formReturn,
  );

  const getRequest = (obj: Imaster): Iconditions => {
    const {
      // retailerId,
      supplierCode,
      storeNo,
      orderDate,
      deliverDate,
      orderNo,
      supplierCodeLike,
      queryDateSelect,
    } = retailerSetup[EnumRetailerSetup.queryConditions];
    return {
      retailerId: obj[EnumMaster.retailerId],
      ...(supplierCode && { supplierCode: obj[EnumMaster.supplierCode] }),
      ...(supplierCodeLike && {
        supplierCodeLike: obj[EnumMaster.supplierCodeLike],
      }),
      ...(storeNo && { storeNo: obj[EnumMaster.storeNo] }),
      ...(orderDate && {
        orderDateBegin: formatDate()(obj[EnumMaster.orderDateBegin]),
        orderDateEnd: formatDate()(obj[EnumMaster.orderDateEnd]),
      }),
      ...(deliverDate && {
        deliverDateBegin: formatDate()(obj[EnumMaster.deliverDateBegin]),
        deliverDateEnd: formatDate()(obj[EnumMaster.deliverDateEnd]),
      }),
      ...(orderNo && {
        orderNoBegin: obj[EnumMaster.orderNoBegin],
        orderNoEnd: obj[EnumMaster.orderNoEnd],
      }),
      ...(queryDateSelect && {
        queryDateSelect: obj[EnumMaster.queryDateValue],
      }),
      ...(queryDateSelect && {
        queryDateBegin: formatDate()(obj[EnumMaster.queryDateBegin]),
        ...(queryDateSelect && {
          queryDateEnd: formatDate()(obj[EnumMaster.queryDateEnd]),
        }),
      }),
      // 判斷是否有勾選[未點閱列印查詢]
      isViewed: isNoViewedPrintChecked ? 'Y' : 'N',
    };
  };

  /** 表單查詢 */
  const handleSearch =
    (
      page = FIRST_PAGE,
      pageSize = pageObj.pageSize,
      keepSelected = true,
      doLoading = true,
    ) =>
    async (input: QueryOrderForm | QueryOrderFormDetail) => {
      const requestPage = {
        pageNo: !isUndefined(page) ? page : pageObj.pageNo,
        pageSize: !isUndefined(pageSize) ? pageSize : pageObj.pageSize,
      };

      const response = await axios.doAxios<
        IqueryOrderRequest,
        {
          contents: Idetail[];
          page: Ipage;
        }
      >(
        MethodEnum.post,
        'order/queryOrder',
        {
          retailerId: input.master[EnumMaster.retailerId],
          conditions: getRequest(input.master),
          sort: masterSort
            .filter((v) => v[EnumMasterSort.property] !== '')
            .map((v) => ({
              ...v,
              [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
            })),
          page: { ...requestPage },
        },
        doLoading,
      );

      setShowResult(true);
      if (
        response &&
        response.data.data &&
        response.data.status === StatusEnum.完成
      ) {
        const { data } = response.data;
        setValueDetail('master', input.master);
        setValueDetail('pageObj', data.page);
        setValueDetail(
          'detail',
          data.contents.map((v, i) => ({
            ...v,
            selected:
              // 刷新資料後 保留selected的值
              keepSelected &&
              v[EnumDetail.orderSeqNo] === detail?.[i]?.[EnumDetail.orderSeqNo]
                ? detail?.[i]?.selected
                : false,
            selectHidden: v[EnumDetail.upFlag] === 'D', // 20230710 sukie.su upFlag = D 訂單刪除，清單不能勾選
          })),
        );
        setValueDetail('masterSort', masterSort); // 20230718 sukie. su 排序也需要傳到後面處理
      } else {
        setValueDetail('detail', []);
      }
      showResponseSnackBar(response?.data);
    };

  /** 取得通路別的欄位顯示設定檔案 */
  const handleUpdateRetailerSetup = async (retailerId: string) => {
    const response = await axios.doAxios<
      unknown,
      { retailerSetup: IretailerSetupOrder }
    >(MethodEnum.post, 'retailerSetup/queryWebRetailerSetup', {
      retailerId,
      functionId: EnumFunctionId.訂單,
      role: userInfoReducer.role,
    });

    if (response) {
      const { data, status } = response.data;
      if (status === StatusEnum.完成) {
        // console.log('111retailerSetup', data.retailerSetup.queryDateList);
        setRetailerSetup({
          [EnumRetailerSetup.queryConditions]: {
            ...initRetailerSetup[EnumRetailerSetup.queryConditions],
            ...data.retailerSetup[EnumRetailerSetup.queryConditions],
          },
          [EnumRetailerSetup.queryResults]: {
            ...initRetailerSetup[EnumRetailerSetup.queryResults],
            ...data.retailerSetup[EnumRetailerSetup.queryResults],
          },
          [EnumRetailerSetup.exportItemList]: {
            ...initRetailerSetup[EnumRetailerSetup.exportItemList],
            ...data.retailerSetup[EnumRetailerSetup.exportItemList],
          },
          [EnumRetailerSetup.queryDateList]: {
            ...initRetailerSetup[EnumRetailerSetup.queryDateList],
            ...data.retailerSetup[EnumRetailerSetup.queryDateList],
          },
        });
        // 不管有沒有值都需要設定，由查詢頁判斷是否顯示物件
        setQueryDateList(data.retailerSetup[EnumRetailerSetup.queryDateList]);
      }
    }
  };

  /** 未點閱列印查詢onChange */
  const handleNoViewedPrintOnChange = (checked: boolean) => {
    // console.log('handleNoViewedPrintChang', checked);
    if (checked) {
      setValue(nameMaster(EnumMaster.orderDateBegin), null);
      setValue(nameMaster(EnumMaster.orderDateEnd), null);
      setValue(nameMaster(EnumMaster.orderNoBegin), null);
      setValue(nameMaster(EnumMaster.orderNoEnd), null);
      setisNoViewedPrintMessage('不包含已驗收、已過期或已刪除之訂單');
    } else {
      setValue(
        nameMaster(EnumMaster.orderDateBegin),
        DATE_RANGE_DEFAULT.startDate,
      );
      setValue(nameMaster(EnumMaster.orderDateEnd), DATE_RANGE_DEFAULT.endDate);
      setisNoViewedPrintMessage('');
    }
    // 設定有啟動未點閱列印
    setIsNoViewedPrintChecked(checked);
  };

  /** 重製表單 */
  const handleReset = () => {
    // 更新defaultValue
    reset(initQueryOrderForm);
    // 取消未點閱勾選
    handleNoViewedPrintOnChange(false);
    // 動態日期預設帶入第一筆，並重新設定開始日期、結束日期
    if (queryDateList != null && queryDateList.length > 0) {
      setValue(nameMaster(EnumMaster.queryDateValue), queryDateOpTrs[0].value);
      handleQueryDateOptionChange(queryDateOpTrs[0].value);
    }
  };

  useEffect(() => {
    const retailerId = initState.master[EnumMaster.retailerId];
    if (retailerId !== '') {
      // 欄位權限取得
      handleUpdateRetailerSetup(retailerId);
    }
    // 由於 initState.master.retailerId 會根據不同的來源有異動，故有變動要重新更新 master
    setValue('master', initState.master);

    // 取得 userInfo 時，或得體系別下拉選單
    setRetailerTypeOption(
      (userInfoReducer?.retailerIds || []).map((v) => ({
        value: v.retailerId,
        label: v.retailerName,
      })),
    );
  }, [userInfoReducer]);

  return (
    <>
      <LogRecordModal
        data={logRecordData}
        _show={[showLogRecordModal, setShowLogRecordModal]}
      />

      <TableTit>
        <span>訂單下載</span>
        <DownloadBtn
          type="order"
          retailerSetup={retailerSetup}
          retailerId={master[EnumMaster.retailerId]}
          retailerIds={userInfoReducer.retailerIds}
        />
      </TableTit>
      <Rim>
        <form
          onSubmit={handleSubmit(
            handleSearch(pageObj.pageNo, pageObj.pageSize, false),
          )}
        >
          <QuerySecion
            _showResult={[showResult, setShowResult]}
            handleReset={handleReset}
            handleUpdateRetailerSetup={handleUpdateRetailerSetup}
            retailerTypeOption={retailerTypeOption}
            formReturn={formReturn}
            _retailerSetup={[retailerSetup, setRetailerSetup]}
            handleNoViewedPrintOnChange={handleNoViewedPrintOnChange}
            isNoViewedPrintChecked={isNoViewedPrintChecked}
            isNoViewedPrintMessage={isNoViewedPrintMessage}
            queryDateOption={queryDateOpTrs}
            handleQueryDateOptionChange={handleQueryDateOptionChange}
          />
          <DivSX className="btn-box">
            <Button
              rounded
              variant={ButtonVariantEnum['outline-primary']}
              startIcon={<i className="icon-redo" />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
            <Button
              type="submit"
              rounded
              startIcon={<i className="icon-common_search-24px" />}
            >
              查詢
            </Button>
          </DivSX>
        </form>
        {showResult && (
          <ResultSecion
            formReturnDetail={formReturnDetail}
            handleSearch={handleSearch}
            _logRecordData={[logRecordData, setLogRecordData]}
            _retailerSetup={[retailerSetup, setRetailerSetup]}
            _showLogRecordModal={[showLogRecordModal, setShowLogRecordModal]}
            userInfoReducer={userInfoReducer}
          />
        )}
      </Rim>
    </>
  );
};
export default QueryReturn;
